import { render, staticRenderFns } from "./MultiDocument.vue?vue&type=template&id=e24f6460&scoped=true"
import script from "./MultiDocument.vue?vue&type=script&lang=ts"
export * from "./MultiDocument.vue?vue&type=script&lang=ts"
import style0 from "./MultiDocument.vue?vue&type=style&index=0&id=e24f6460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24f6460",
  null
  
)

export default component.exports